import api from 'app/api';
import { Services } from 'modules/common/enums/Services';
import { GeneralThemeType } from '../types/GeneralThemeType';

const SERVICE = Services.BACKEND;

export const fetchGeneralSettings = async () => {
    const response = await api.get(SERVICE + "/setting/general/index");

    return response;
};

export const apiUpdateGeneralThemeSettings = async (data: GeneralThemeType) => {
    const response = await api.post(SERVICE + "/setting/general/update", data);

    return response;
};